import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, Redirect } from "react-router-dom";
import {
  httpGetThreeNotesByProfileId,
  httpGetVendorProfileByEmail,
  httpGetVendorProfileById,
  httpGetVendorStatusDetails,
  httpGetMandatoryDocumentStatus,
  httpGetDownloadFileByVendorId,
  httpGetConfigValues,
} from "../../service/httpClient";
import DVNSetup from "./Views/DVNSetup/DVNSetup";
import { Col, Row, Container, Spinner } from "react-bootstrap";
import LeftSideNav from "./Views/LeftSideNav/LeftSideNav";
import { updateServiceData } from "../../redux/serviceSlice";
import { updateCommonInfo } from "../../redux/commonSlice";
import * as _ from "../../constants/Constants";
import { updateLeftNav } from "../../redux/leftNavSlice";
import DocumentCenter from "./Views/DocumentCenter/DocumentCenter";
import Header from "./Views/TabHeader/TabHeader";
import TitleName from "./Views/TabHeader/TitleName";
import OPSWorkflow from "./Views/OPSWorkflow/OPSWorkflow";
import RightNotes from "./Views/RightNotes/RightNotes";
import VendorProfile from "./Views/VendorProfile";
import Address from "./Views/Address/Address";
import MerchantApproval from "./Views/MerchantApproval/MerchantApproval";
import MerchantApprovalBrand from "./Views/MerchantApproval/MerchantApprovalBrand";
import ContactDetails from "./Views/Contact/ContactDetails";
import Notes from "./Views/Notes/Notes";
import Company from "./Views/Company/Company";
import EINVerification from "./Views/EINVerification/EINVerification";
import DVNAudit from "./Views/DVNAudit/DVNAudit";
import ErrorContainer from "../Common/Errors/ErrorContainer";
import {
  checkUserRoles,
  checkOnBoardingStatus,
  checkMandatoryDocStatus,
} from "../../utils/utils";
import { convertDate } from "../../utils/DateUtility";
import { verifyAccessPermission } from "../../utils/rolePermissionAccess";

export const extractVendorStatus = (vendorDetailStatus, vendorStatus) => {
  let mutatedVendorStatus = {};

  if (vendorStatus.length) {
    vendorStatus.forEach((status, index) => {
      const statusValue = status?.vendorStatus?.lastStatusUpdatedValue || "";

      mutatedVendorStatus[status?.statusName] = statusValue;
      if (index === 0) {
        mutatedVendorStatus[_.ONBOARDING_STATUS] =
          status?.onboardingStatus || "";
        mutatedVendorStatus[_.MERCHANT_APPROVAL_ID] =
          vendorDetailStatus || _.PENDING;
      }
    });
  }

  return { mutatedVendorStatus };
};

const OnboardingContainer = (props) => {
  const pageType = props.match.params?.type;
  const pageStep = props.match.params?.step;
  const currentPageParam = pageType || pageStep;
  const location = useLocation();
  const dispatch = useDispatch();
  const store = useSelector(
    ({ service, common }) => ({
      fetching: service.fetching,
      vendorProfileId: service.vendorProfile?.vendorDetail?.id || "",
      vendorDetails: service.vendorProfile?.vendorDetail,
      profileId: common.profileId,
      notes: service.notes,
      externalVendorEmail: common?.externalVendorEmail,
      onboardingStatus: common.boardingStatuses?.onboardingStatus,
      roleName: service.roles?.roleName,
      vendorStatus: service.vendorStatus || [],
      extUserEnabled: verifyAccessPermission("extUserEnabled")
        ? service?.vendorProfile && service?.vendorProfile?.primaryContact
          ? true
          : false
        : true,
      duns: common.duns,
      merchandiseType:
        service.vendorProfile?.vendorDetail?.merchandiseType || "",
      mandatoryDocRes: common?.mandatoryDocRes,
      documentList: common?.documentList,
      vendorProfile: service?.vendorProfile,
      configValues: common?.configValues,
      vendorHasDeleted: common?.vendorHasDeleted,
    }),
    shallowEqual
  );

  const notesRef = useRef(null);

  const [vendorSelected, setVendorSelected] = useState(true);
  const [documentStatusRes, setDocumentStatusRes] = useState({});

  const onboardingStatusFlag =
    store?.onboardingStatus !== "" &&
    checkOnBoardingStatus(store?.onboardingStatus, [
      _.DOCUMENT_SUBMITTED,
      _.DBM_APPROVED,
    ]);

  const onboardStatusBeyondInprocessStatus =
    store?.onboardingStatus !== "" &&
    checkOnBoardingStatus(store?.onboardingStatus?.toLowerCase(), [
      _.IN_PROCESS?.toLowerCase(),
      _.HOLD_STATE?.toLowerCase(),
      _.OB_COMPLETE?.toLowerCase(),
      _.LIVE_ID?.toLowerCase(),
      _.STATUS_INACTIVE_INTEGRATION_HOLD.toLowerCase(),
      _.STATUS_INACTIVE_UNRESPONSIVE.toLowerCase(),
    ]);

  useEffect(() => {
    if (store?.configValues?.length === 0) getConfigValues();
  }, []);

  useEffect(() => {
    const { vendorProfileId, profileId, fetching, externalVendorEmail } = store;
    const fetchVendor = vendorProfileId.toString() !== profileId || fetching;

    setVendorSelected(profileId || externalVendorEmail);

    if (profileId && fetchVendor) {
      localStorage.setItem("vid", profileId);
      fetchVendorData(profileId);
    }

    if (!profileId && externalVendorEmail && fetching) {
      httpGetVendorProfileByEmail(externalVendorEmail)
        .then((res) => {
          const vendorProfileId = filterVendorProfileId(res.data || {});

          if (vendorProfileId) {
            fetchVendorData(vendorProfileId, false);
          } else {
            extractVendorProfile(res.data);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [store.profileId, store.externalVendorEmail]);

  useEffect(() => {
    let mandatoryDocStatusRes = checkMandatoryDocStatus(
      store.onboardingStatus,
      documentStatusRes
    );

    dispatch(
      updateCommonInfo({
        mandatoryDocStatusRes: mandatoryDocStatusRes,
        mandatoryDocRes: documentStatusRes,
      })
    );
  }, [store.onboardingStatus, documentStatusRes]);

  const getConfigValues = () => {
    httpGetConfigValues()
      .then((response) => {
        dispatch(
          updateCommonInfo({
            configValues: response.data,
          })
        );
      })
      .catch((err) => console.log(err));
  };

  const getUpdatedVendorData = (vendorProfileId) => {
    return new Promise((resolve, reject) => {
      Promise.allSettled([
        httpGetVendorProfileById(vendorProfileId),
        httpGetVendorStatusDetails(vendorProfileId),
        httpGetMandatoryDocumentStatus(vendorProfileId),
      ])
        .then(([profileRes, statusRes, documentStatusRes]) => {
          let vendorProfile = profileRes.value?.data;
          let vendorStatus = statusRes.value?.data;
          let mandatoryDocStatusRes = checkMandatoryDocStatus(
            store.onboardingStatus,
            documentStatusRes.value?.data
          );
          const mandatoryDocRes = documentStatusRes.value?.data || {};

          setDocumentStatusRes(documentStatusRes.value?.data || {});
          extractVendorProfile(
            vendorProfile,
            vendorStatus,
            mandatoryDocStatusRes,
            mandatoryDocRes
          );
          resolve();
        })
        .catch((err) => {
          setDocumentStatusRes({});
          reject(err);
        });
    });
  };

  const fetchVendorData = (vendorProfileId, getNotes = true) => {
    getUpdatedVendorData(vendorProfileId).catch((err) => console.log(err));

    getNotes && getTopThreeNotes(vendorProfileId);
  };

  const filterVendorProfileId = (vendorData = {}) => {
    let vendorProfileId = "";
    for (const dataKey in vendorData) {
      if (
        vendorData[dataKey] &&
        typeof vendorData[dataKey] === "object" &&
        !Array.isArray(vendorData[dataKey]) &&
        vendorData[dataKey].vendorProfileId
      ) {
        vendorProfileId = vendorData[dataKey].vendorProfileId;
        break;
      }
    }
    return vendorProfileId;
  };

  const extractVendorProfile = (
    vendorProfile,
    vendorStatus = [],
    mandatoryDocStatusRes = false,
    mandatoryDocRes = {}
  ) => {
    const {
      vendorDetail,
      primaryContact,
      mailAddress,
      merchantContact,
      multipleMerchantContactList,
    } = vendorProfile || {};
    const { duns, vendorConnectionPlatform, vendorCorpName, status } =
      vendorDetail || {};
    const { mutatedVendorStatus } = extractVendorStatus(
      status || "",
      vendorStatus
    );

    dispatch(
      updateServiceData({
        vendorProfile,
        vendorStatus,
        fetching: false,
        merchantContact,
        multipleMerchantContactList,
      })
    );
    dispatch(
      updateLeftNav({
        primaryContact: {
          userEmail: primaryContact?.userEmail || "",
          vendorPhone: primaryContact?.phoneNumber || "",
          streetAddress: mailAddress?.streetAddress || "",
          city: mailAddress?.city || "",
          state: mailAddress?.state || "",
          zipCode: mailAddress?.zipCode || "",
        },
      })
    );
    dispatch(
      updateCommonInfo({
        boardingStatuses: mutatedVendorStatus,
        vendorCorpName: vendorCorpName || "",
        duns: duns || "",
        userEmail: primaryContact?.userEmail || "",
        vendorConnectionPlatform: vendorConnectionPlatform || "",
        vendorPhone: primaryContact?.phoneNumber || "",
        profileId: vendorDetail?.id?.toString() || store.profileId || "",
        mandatoryDocStatusRes: mandatoryDocStatusRes || false,
        mandatoryDocRes: mandatoryDocRes || {},
        vendorHasDeleted: false,
      })
    );
  };

  const setFetchingTrue = () => dispatch(updateServiceData({ fetching: true }));

  const getTopThreeNotes = (profileId = null) => {
    const vendorProfileId = store.profileId || profileId || "";
    if (vendorProfileId) {
      httpGetThreeNotesByProfileId(vendorProfileId)
        .then((res) => {
          dispatch(
            updateServiceData({
              notes: res.data,
            })
          );
        })
        .catch((error) => console.log(error));
    }
  };

  const getAllNotes = () => notesRef?.current?.refreshNotes();

  const pathname = props.location.pathname;

  const refreshDataAfterActionSuccessful = (newVendorStatus) => {
    httpGetVendorStatusDetails(store.vendorProfileId)
      .then((res) => {
        const { mutatedVendorStatus } = extractVendorStatus(
          store.vendorDetails.status,
          res.data
        );

        //update vendorStatus in service data
        dispatch(
          updateServiceData({
            vendorStatus: res.data,
          })
        );
        //update vendorstatus in common slice
        dispatch(
          updateCommonInfo({
            boardingStatuses: mutatedVendorStatus,
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const documentTypeRename = (data) => {
    const documentArr = data.map((p) =>
      p.fileType === _.MINORITY_BUSINESS_DOCUMENTATION
        ? { ...p, fileType: "MBE/WBEBusinessDocumentation" }
        : p
    );

    return documentArr;
  };

  const getDocumentList = () => {
    const data = [];
    httpGetDownloadFileByVendorId(store?.vendorProfileId)
      .then((response) => {
        response.data.forEach((rec) => {
          let date = convertDate(rec.updatedAt);
          rec.updatedAt = date;
          data.push(rec);
        });

        const documentArr = documentTypeRename(data);
        dispatch(
          updateCommonInfo({
            documentList: documentArr,
          })
        );
      })
      .catch((error) => {
        dispatch(
          updateCommonInfo({
            documentList: [],
          })
        );
      });
  };

  return (
    <>
      <Container
        fluid
        style={{
          padding: 0,
          overflowX: pathname.includes("merchantbrand") ? "hidden" : undefined,
        }}
      >
        <Row style={{ padding: 0 }}>
          <Col xs={12} sm={6} md={4} xl={3} xxl={3} style={{ padding: 0 }}>
            <LeftSideNav params={props.match.params} />
          </Col>
          <Col
            xs={12}
            sm={12}
            md={pathname.includes("brand") ? 12 : 8}
            xl={pathname.includes("brand") ? 9 : 7}
            xxl={7}
            className="onboarding_centerArea"
            //  style={pathname.includes("brand") ? { paddingRight: "20px" } : ""}
          >
            {store.fetching && vendorSelected && (
              <Spinner
                animation="border"
                variant="danger"
                style={{
                  width: "50px",
                  height: "50px",
                  marginRight: 5,
                  position: "absolute",
                  top: "32vh",
                  left: "28vw",
                }}
              />
            )}
            <Row>
              <Header
                setFetchingTrue={setFetchingTrue}
                getTopThreeNotes={getTopThreeNotes}
                getAllNotes={getAllNotes}
                vendorProfileId={store.profileId}
                onboardingStatus={store.onboardingStatus}
                refreshDataAfterActionSuccessful={
                  refreshDataAfterActionSuccessful
                }
                fetchVendorData={fetchVendorData}
                duns={store.duns}
                vendorStatus={store.vendorStatus}
                vendorProfileDetails={store.vendorDetails}
                title={
                  _.pageHeaderTitlesByRoute[
                    currentPageParam
                      ? currentPageParam
                      : pathname.includes("vendor")
                      ? _.COMPANY
                      : "merchant"
                  ]
                }
                extractVendorStatus={extractVendorStatus}
              />
              <TitleName
                title={
                  _.pageHeaderTitlesByRoute[
                    currentPageParam
                      ? pathname.includes("brand")
                        ? "dvnbrand"
                        : currentPageParam
                      : pathname.includes("vendor")
                      ? _.COMPANY
                      : pathname.includes("merchantbrand")
                      ? "brand"
                      : pathname.includes("dvnbrand")
                      ? "dvnbrand"
                      : "merchant"
                  ]
                }
                hideTooltip={
                  pathname.includes("merchantbrand") ||
                  pathname.includes("dvnbrand") ||
                  pageType === _.EIN_VERIFICATION ||
                  pageType === _.DVN_AUDIT
                }
              />
            </Row>
            {!vendorSelected && (
              <Row>
                <Col>
                  {store?.vendorHasDeleted && (
                    <p style={{ color: "#02e202" }}>
                      {_.VENDOR_DELETED_SUCCESS_MSG}
                    </p>
                  )}
                  <ErrorContainer
                    errorMsg={_.VOB_NO_VENDOR_SELECTED_MSG}
                    errorStatus={true}
                    errorStyle="errorMessage"
                  />
                </Col>
              </Row>
            )}
            {!store.fetching && vendorSelected && (
              <>
                {(pageType === _.COMPANY ||
                  (!pageType && pathname.includes("vendor"))) && (
                  <Company
                    history={props.history}
                    extUserEnabled={store.extUserEnabled}
                    merchandiseType={store.merchandiseType}
                    onboardingStatusFlag={onboardingStatusFlag}
                    onboardingStatus={store?.onboardingStatus}
                    onboardStatusBeyondInprocessStatusFlag={
                      onboardStatusBeyondInprocessStatus
                    }
                    refreshDataAfterActionSuccessful={
                      refreshDataAfterActionSuccessful
                    }
                    getConfigValues={getConfigValues}
                  />
                )}

                {pageType === _.ADDRESS && (
                  <Address
                    vendorProfileId={store.profileId}
                    email={store.externalVendorEmail}
                    userRoleName={store.roleName}
                    setFetchingTrue={setFetchingTrue}
                    extUserEnabled={store.extUserEnabled}
                    merchandiseType={store.merchandiseType}
                    onboardingStatusFlag={onboardingStatusFlag}
                  />
                )}

                {pathname.includes("merchant") &&
                  !pathname.includes("brand") &&
                  store.vendorDetails && (
                    <MerchantApproval
                      history={props.history}
                      getTopThreeNotes={getTopThreeNotes}
                      onboardingStatusFlag={onboardingStatusFlag}
                      setDocumentStatusRes={(data) =>
                        setDocumentStatusRes(data)
                      }
                      onboardStatusBeyondInprocessStatusFlag={
                        onboardStatusBeyondInprocessStatus
                      }
                      onboardingStatus={store?.onboardingStatus}
                      refreshDataAfterActionSuccessful={
                        refreshDataAfterActionSuccessful
                      }
                      getDocumentList={getDocumentList}
                    />
                  )}
                {pathname.includes("brand") && store.vendorDetails && (
                  <div>
                    <MerchantApprovalBrand
                      history={props.history}
                      viewOnMerchApproval={false}
                      details={location.state}
                    ></MerchantApprovalBrand>
                  </div>
                )}

                {pageType === _.CONTACT && (
                  <ContactDetails
                    history={props.history}
                    extUserEnabled={store.extUserEnabled}
                    merchandiseType={store.merchandiseType}
                    onboardingStatusFlag={onboardingStatusFlag}
                  />
                )}

                {pageType === _.PB_VENDOR_PROFILE && store.vendorDetails && (
                  <>
                    {store.merchandiseType ===
                      _.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
                    _.STATUS_PLATFORMTYPE_MIRAKL.includes(
                      store.vendorDetails?.vendorConnectionPlatform
                    ) ? (
                      <Redirect
                        to={`/boarding/vendor/company/${store.vendorProfileId ||
                          ""}`}
                      />
                    ) : (
                      <VendorProfile
                        onboardingStatus={store.onboardingStatus}
                        vendorProfileDetails={store.vendorDetails}
                        roleName={store.roleName}
                        getUpdatedVendorData={getUpdatedVendorData}
                      />
                    )}
                  </>
                )}

                {pageType === _.EIN_VERIFICATION && store.vendorDetails && (
                  <EINVerification
                    history={props.history}
                    merchandiseType={store.vendorDetails.merchandiseType}
                    vendorConnectionPlatform={
                      store.vendorDetails.vendorConnectionPlatform
                    }
                    vendorProfileId={store.vendorProfileId}
                    vendorDetails={store.vendorDetails}
                    vendorStatus={store.vendorStatus}
                    extractVendorStatus={extractVendorStatus}
                  />
                )}
                {pageType === _.DVN_AUDIT && store.vendorDetails && (
                  <DVNAudit
                    vendorDetails={store.vendorDetails}
                    getUpdatedVendorData={getUpdatedVendorData}
                  />
                )}

                {pageType === _.DVNSETUP &&
                  !pathname.includes("dvnbrand") &&
                  store.vendorDetails && (
                    <DVNSetup
                      vendorProfileDetails={store.vendorDetails}
                      onboardingStatus={store.onboardingStatus}
                      viewOnMerchApproval={false}
                      history={props.history}
                      getDocumentList={getDocumentList}
                      refreshDataAfterActionSuccessful={
                        refreshDataAfterActionSuccessful
                      }
                    />
                  )}

                {pageType === _.DOC_CENTER && store.vendorDetails && (
                  <DocumentCenter
                    vendorId={store.profileId}
                    vendorDetails={store.vendorDetails}
                    onboardingStatusFlag={onboardingStatusFlag}
                    onboardingStatus={store.onboardingStatus}
                    getDocumentList={getDocumentList}
                    vendorProfile={store?.vendorProfile}
                    refreshDataAfterActionSuccessful={
                      refreshDataAfterActionSuccessful
                    }
                  />
                )}

                {pageStep && store.vendorDetails && (
                  <>
                    {store.merchandiseType ===
                      _.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
                    _.STATUS_PLATFORMTYPE_MIRAKL.includes(
                      store.vendorDetails?.vendorConnectionPlatform
                    ) &&
                    ![7, 17].includes(parseInt(pageStep)) ? ( // Allow Live and UPS account for MP
                      <Redirect
                        to={`/boarding/vendor/company/${store.vendorProfileId ||
                          ""}`}
                      />
                    ) : (
                      <OPSWorkflow
                        step={pageStep}
                        roleName={store.roleName}
                        isMPVendor={
                          store.merchandiseType ===
                            _.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
                          _.STATUS_PLATFORMTYPE_MIRAKL.includes(
                            store.vendorDetails?.vendorConnectionPlatform
                          )
                        }
                      />
                    )}
                  </>
                )}

                {pageType === _.NOTES && store.vendorDetails && (
                  <Notes ref={notesRef} />
                )}
              </>
            )}
          </Col>

          {store.notes.length > 0 && !pathname.includes("brand") && (
            <Col
              xs={12}
              sm={6}
              md={4}
              xl={2}
              xxl={2}
              style={{ paddingRight: 0 }}
            >
              <div className="rightNotes">
                {verifyAccessPermission("viewRightNotes") && (
                  <RightNotes notes={store.notes} />
                )}
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
};

export default OnboardingContainer;
